export default "__VITE_ASSET__21accf09__"